import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { RestService } from "../../../core/services/rest.service";

@Component({
  selector: "app-editor-generate-confirmation",
  standalone: true,
  imports: [],
  templateUrl: "./editor-generate-confirmation.component.html",
  styleUrl: "./editor-generate-confirmation.component.scss",
})
export class EditorGenerateConfirmationComponent {
  activeModal = inject(NgbActiveModal);
  @Input() projectId: any = "";
  isActive:boolean = false;
  constructor(private restService: RestService) {}

  downloadExtentioComponent() {
    this.restService.getRecorderExtention().subscribe((item: any) => {
      console.log("Download URL", item?.data?.signedUrl);
      window.open(item?.data?.signedUrl, "_blank");
    });
  }

  loadRecordActivities() {
    this.activeModal.close({
      type: "load-record-activities",
    });
  }
}
